import { get } from '../../../libs/Requests';
import { IPromoCodeDTO } from '../../../../../types/PromoCodeDTO';

export function getPromoCode(code: string) {
  return get(`/promo_codes/${code}`).then(async (response) => {
    if (response.status !== 200) {
      throw new Error('Invalid promo code');
    }

    const promoCodeDto = (await response!.json()) as IPromoCodeDTO;

    if (!promoCodeDto.valid) {
      throw new Error('Invalid promo code');
    }

    return promoCodeDto;
  });
}
